export enum DashboardChartTitles {
  CONVERSATIONS = 'Conversations',
  DIRECT_TO_SV = 'Temp',
  NOTIFICATIONS = 'Notifications',
}

export enum DashboardChartTypes {
  LINE = 'line',
  DOUGHNUT = 'doughnut',
}
